/**
 * The line's frame: an antd Modal hosting LineView, the way RoutesDialog
 * hosts the route explorer. Conditional-mounted, so the worker is created on
 * open and disposed on close, and the runs start fresh each time.
 */

import { Modal } from 'antd'
import { tOr } from '../../i18n/i18n'
import { useLang } from '../i18n/LanguageProvider'
import { LineView } from './LineView'

export function LineDialog({ onClose }: { onClose: () => void }) {
  useLang()
  return (
    <Modal
      open
      onCancel={onClose}
      footer={null}
      title={tOr('line.Title', 'The line — a chiller trip at 02:00')}
      width="min(1180px, 96vw)"
      styles={{ body: { maxHeight: '82vh', overflowY: 'auto' } }}
      centered
    >
      <LineView />
    </Modal>
  )
}
